import Plot from "react-plotly.js";
import { useTheme } from "../../theme/useTheme";

const Heatmap = (props: any) => {
  console.log("Heatmap props:", props);
  const { mode } = useTheme();
  // Calculate min and max values dynamically
  const flattenedValues = props.zaxisvalues.flat();
  const minValue = Math.min(...flattenedValues);
  const maxValue =
    Math.min(...flattenedValues) === Math.max(...flattenedValues)
      ? Math.max(...flattenedValues) + 1
      : Math.max(...flattenedValues);

  // Determine symmetric range for diverging color scale
  const absMax = Math.max(Math.abs(minValue), Math.abs(maxValue));

  // Use rowNames if provided, otherwise use default yaxisvalues
  const yAxisLabels =
    props.rowNames && props.rowNames.length > 0
      ? props.rowNames
      : props.yaxisvalues;

  // Determine height based on title
  const height =
    props.title && props.title.toLowerCase().includes("reichart")
      ? "400px"
      : "250px";

  return (
    <div style={{ width: "100%", height }}>
      <Plot
        layout={{
          title: {
            text: props.title,
            x: 0.5,
            xanchor: "center",
            y: 0.98,
            font: { color: mode === "dark" ? "#e5e7eb" : "#111827" },
          },
          showlegend: false,
          autosize: true,
          paper_bgcolor: "rgba(0,0,0,0)",
          plot_bgcolor: "rgba(0,0,0,0)",
          modebar: {
            bgcolor: "rgba(0,0,0,0)",
            color: mode === "dark" ? "#9ca3af" : "#6b7280",
            activecolor: mode === "dark" ? "#e5e7eb" : "#111827",
          },
          xaxis: {
            side: "bottom",
            tickangle: -90,
            tickfont: {
              size: 14,
              color: mode === "dark" ? "#d1d5db" : "#374151",
            },
            showgrid: false,
            zeroline: false,
            ticks: "",
          },
          yaxis: {
            showticklabels:
              Array.isArray(props.rowNames) && props.rowNames.length > 0,
            tickfont: {
              size: 12,
              color: mode === "dark" ? "#d1d5db" : "#374151",
            },
            showgrid: false,
            zeroline: false,
            ticks: "",
            autorange: "reversed",
            ...(props.rowNames &&
              props.rowNames.length > 0 && {
                tickmode: "array",
                tickvals: Array.from(
                  { length: props.rowNames.length },
                  (_, i) => i,
                ),
                ticktext: props.rowNames,
              }),
          },
          margin: { l: 50, r: 30, t: 60, b: 120 },
        }}
        data={[
          {
            type: "heatmap" as const,
            hoverongaps: false,
            z: props.zaxisvalues,
            x: props.xaxisvalues,
            y: yAxisLabels,
            zmin: -absMax,
            zmax: absMax,
            xgap: 2,
            ygap: 2,
            colorscale: [
              [0, "#2166ac"], // Dark blue for negative
              [0.25, "#92c5de"], // Light blue for negative
              [0.5, "#cccccc"], // White for zero
              [0.75, "#f4a582"], // Light red/orange for positive
              [1, "#b2182b"], // Dark red for positive
            ],
            showscale: true,
            colorbar: {
              thickness: 25,
              len: 1,
              x: 1.2,
              y: 0.5,
              xpad: 0,
              tickmode: "array",
              tickvals: [-absMax, 0, absMax],
              ticktext: [`${-absMax.toFixed(1)}`, "0", `${absMax.toFixed(1)}`],
              tickfont: {
                size: 14,
                color: mode === "dark" ? "#d1d5db" : "#374151",
                family: "Arial, sans-serif",
              },
              outlinewidth: 1,
              outlinecolor: mode === "dark" ? "#6b7280" : "#d1d5db",
              borderwidth: 0,
              title: {
                text: "",
                side: "right",
              },
            },
            hovertemplate:
              props.rowNames && props.rowNames.length > 0
                ? "<b>%{x}</b><br>%{y}: %{z:.2f}<extra></extra>"
                : "<b>%{x}</b><br>%{z:.2f}<extra></extra>",
            showlegend: false,
          },
          // Legend trace for "In KG"
          {
            type: "scatter" as const,
            mode: "markers",
            x: [null],
            y: [null],
            marker: {
              size: 12,
              color: "#1abc9c",
            },
            name: "In KG",
            showlegend: true,
            hoverinfo: "none",
          },
          // Legend trace for "Not in KG"
          {
            type: "scatter" as const,
            mode: "markers",
            x: [null],
            y: [null],
            marker: {
              size: 12,
              color: "#d3d3d3",
              line: {
                color: "#999999",
                width: 1,
              },
            },
            name: "Not in KG",
            showlegend: true,
            hoverinfo: "none",
          },
        ]}
        config={{
          responsive: true,
          displayModeBar: true,
          displaylogo: false,
          modeBarButtons: [["toImage"]],
          modeBarButtonsToRemove: [
            "zoomIn2d",
            "zoomOut2d",
            "resetScale2d",
            "lasso2d",
            "select2d",
            "hoverClosestCartesian",
            "hoverCompareCartesian",
            "sendDataToCloud",
          ],
          toImageButtonOptions: {
            format: "png",
            filename: `${props.title.split(" ").join("_")}_heatmap`,
          },
        }}
        style={{ width: "100%", height: "100%" }}
        useResizeHandler={true}
      />
    </div>
  );
};

export default Heatmap;
